import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class EventResource extends AuthenticatedResource {
  static urlRoot = 'profile/:organization_slug/events';

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}